<div class="content-renderer" [ngSwitch]="content?.type">

    <!-- Text Content -->
    <div *ngSwitchCase="'text'" class="text-content">
        <h4 *ngIf="content.metadata?.title" class="content-title">{{ content.metadata.title }}</h4>
        <div class="text-body" [ngClass]="{'edit-message': !isBotMessage}">
            <div class="streaming-container">
                <div [innerHTML]="formatText(displayedText)"></div>
                <span *ngIf="isStreaming" class="typing-cursor">|</span>
            </div>
        </div>
    </div>

    <!-- Table Content -->
    <div *ngSwitchCase="'table'" class="table-content">
        <div class="table-header" *ngIf="content.metadata?.title">
            <h4 class="content-title">{{ content.metadata.title }}</h4>
            <button class="copy-button" (click)="copyToClipboard(getTableAsText())">
            </button>
        </div>

        <div class="table-container">
            <table [dataSource]="getTableDataSource()" class="chat-table">
                <ng-container *ngFor="let column of getTableColumns(); let i = index">
                    <th>{{ content.data.headers[i] }}</th>
                    <td>{{ row[column] }}</td>
                </ng-container>

                <tr></tr>
                <tr></tr>
            </table>
        </div>
    </div>

    <!-- List Content -->
    <div *ngSwitchCase="'list'" class="list-content">
        <h4 *ngIf="content.metadata?.title" class="content-title">{{ content.metadata.title }}</h4>

        <ul *ngIf="content.data.type === 'unordered'" class="unordered-list">
            <li *ngFor="let item of content.data.items">
                <span [innerHTML]="formatText(item)"></span>
            </li>
        </ul>

        <ol *ngIf="content.data.type === 'ordered'" class="ordered-list">
            <li *ngFor="let item of content.data.items">
                <span [innerHTML]="formatText(item)"></span>
            </li>
        </ol>
    </div>

    <!-- Code Content -->
    <div *ngSwitchCase="'code'" class="code-content">
        <div class="code-header">
            <h4 *ngIf="content.metadata?.title" class="content-title">{{ content.metadata.title }}</h4>
            <div class="code-actions">
                <span *ngIf="content.metadata?.language" class="language-tag">{{ content.metadata.language }}</span>
                <button class="copy-button" (click)="copyToClipboard(content.data)">
                </button>
            </div>
        </div>

        <div class="code-block">
            <div class="streaming-container">
                <pre><code [class]="'language-' + (content.metadata?.language || 'text')">{{ displayedText }}<span *ngIf="isStreaming" class="typing-cursor">|</span></code></pre>
            </div>
        </div>
    </div>

    <!-- Markdown Content -->
    <div *ngSwitchCase="'markdown'" class="markdown-content">
        <h4 *ngIf="content.metadata?.title" class="content-title">{{ content.metadata.title }}</h4>
        <div class="markdown-body">
            <div class="streaming-container">
                <div [innerHTML]="formatText(displayedText)"></div>
                <span *ngIf="isStreaming" class="typing-cursor">|</span>
            </div>
        </div>
    </div>

    <!-- HTML Content -->
    <div *ngSwitchCase="'html'" class="html-content">
        <div class="html-header" *ngIf="content.metadata?.title">
            <h4 class="content-title">{{ content.metadata.title }}</h4>
            <button class="copy-button" title="click to copy" (click)="copyToClipboard(content.data)">
                <span>Copy</span>
            </button>
        </div>
        <div class="html-body" [innerHTML]="getSafeHtml(content.data)"></div>
    </div>

    <!-- Default/Unknown Content -->
    <div *ngSwitchDefault class="default-content">
        <h4 *ngIf="content?.metadata?.title" class="content-title">{{ content.metadata.title }}</h4>
        <div class="default-body">
            <pre>{{ content?.data | json }}</pre>
        </div>
    </div>

</div>